import { sizes } from './sizes';

export const spacing = {
  navbarHeight: sizes.navbarHeight,
  sidebarWidth: sizes.sidebarWidth,
  sidebarCollapse: sizes.sidebarCollapse,
  sidebarPx: '1.25rem',
  sidebarPxHalf: '0.625rem'
};
